module.exports = __webpack_public_path__ + "static/media/scenery_big_img.877e92f0.jpg";